import { render, staticRenderFns } from "./ProjectDesignAndCustomer.vue?vue&type=template&id=219d4190&"
import script from "./ProjectDesignAndCustomer.vue?vue&type=script&lang=js&"
export * from "./ProjectDesignAndCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports